import { CONSENT_KEY, buildConsentRecord, parseConsentRecord } from './consentRecord';

export const CONSENT_CHANGE_EVENT = 'ivori:consent-change';
export const OPEN_SETTINGS_EVENT = 'ivori:open-cookie-settings';

// Set only when localStorage refuses the write (private mode, blocked
// storage): the choice then holds for this page only, and the banner returns
// on the next load.
let memoryChoice = null;
let opener = null;

/** The current valid choice, or null when there is none (so: no consent). */
export function getChoice() {
  if (memoryChoice) return memoryChoice;
  try {
    return parseConsentRecord(window.localStorage.getItem(CONSENT_KEY), Date.now());
  } catch (_) {
    return null;
  }
}

/** The only check app code may use before it calls gtag or sends analytics. */
export function consentAllows(purpose) {
  const choice = getChoice();
  return !!choice && choice[purpose] === true;
}

/**
 * Stores a choice, applies it (loads tags, or purges cookies for purposes now
 * off), tells listeners, and reloads when a tag that is already running has
 * lost a purpose. Returns true when the choice was persisted to localStorage.
 */
export function saveChoice(choice, { now = Date.now, reload = () => window.location.reload() } = {}) {
  const record = buildConsentRecord(choice, now());
  let persisted = false;
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
    persisted = true;
    memoryChoice = null;
  } catch (_) {
    memoryChoice = { analytics: record.analytics, recording: record.recording, advertising: record.advertising };
  }
  const applied = { analytics: record.analytics, recording: record.recording, advertising: record.advertising };
  const gate = typeof window !== 'undefined' ? window.__ivoriConsent : undefined;
  const needsReload = gate && typeof gate.applyChoice === 'function' ? gate.applyChoice(applied) === true : false;
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: applied }));
  if (needsReload) reload();
  return persisted;
}

/** Opens the cookie settings panel from anywhere (footers, menus, the policy). */
export function openCookieSettings() {
  opener = typeof document !== 'undefined' ? document.activeElement : null;
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT));
}

/** The element that opened the panel, so focus can go back to it. */
export function getSettingsOpener() {
  return opener;
}

export function clearSettingsOpener() {
  opener = null;
}
